import config from 'config';
import sfax from 'sfax';

sfax.baseUrl = '';

const { domain, bbsDomain } = config;

export default {
    getCityForumPv: payload => sfax({
        url: `${bbsDomain}/topic/ajaxGetListTopicPv`,
        data: payload,
        withCredentials: true,
        contentType: 'application/json'
    }),
    getCityFeed: payload => sfax({
        url: `/baseApi/loupanSearchForIndex`,
        data: payload,
        contentType: 'application/json'
    }),
    getCityListData: payload => sfax({
        url: `//house-sv-base.focus.cn/city/list`,
        data: payload
    }),
    // getMessageCode: url => sfax({
    //     url: url,
    //     withCredentials: true,
    //     jsonp: true
    // }),
    getMessageCode: (url, payload) => sfax({
        url: url,
        withCredentials: true,
        data: payload,
        jsonp: true
    }),
    sendCondoTourInfo: payload => sfax({
        type: 'post',
        url: '/baseApi/kanFangTuanApply',
        // url: '/MOCK/baseApi/kanFangTuanApply',
        data: payload,
        withCredentials: true
    }),
    getIndexFurnishing: payload => sfax({
        url: '/baseApi/getIndexHomeByType',
        data: payload,
        withCredentials: true,
        contentType: 'application/json'
    }),
    getIndexRentHouse: payload => sfax({
        url: '/baseApi/getIndexRentByType',
        data: payload,
        withCredentials: true,
        contentType: 'application/json'
    }),
    getUserInfo: url => sfax({
        url: url,
        withCredentials: true,
        jsonp: true
    })
};



// WEBPACK FOOTER //
// ./src/model/api/city.js